import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialContainerTypePageState,
  ContainerTypeItemData,
} from "../core/_model.containerType";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedContainerType = {
  data: ContainerTypeItemData | null;
  action: ActionsKey;
};

type ContainerTypeDataType = {
  containerTypeList: any;
  detail: ContainerTypeItemData | null;
  actioned: ActionedContainerType | null;
  totalItems?: number;
  setDetail: (detail: ContainerTypeItemData | null) => void;
  setContainerTypeList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedContainerType | null) => void;
};

export const useContainerTypeStore = create<ContainerTypeDataType>(
  (set) => ({
    containerTypeList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setContainerTypeList: (saleData) =>
      set((state) => ({
        containerTypeList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useContainerTypeListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialContainerTypePageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
